export const isUnreadNotification = (notification) => {
  if (!notification) return false;

  if (typeof notification.read === 'boolean') {
    return !notification.read;
  }

  if (Array.isArray(notification.userNotifications)) {
    return notification.userNotifications.some((entry) => entry?.read === false);
  }

  return true;
};

export const getUnreadNotificationCount = (notifications = []) => {
  if (!Array.isArray(notifications)) return 0;

  return notifications.reduce((count, notification) => {
    if (isUnreadNotification(notification)) {
      return count + 1;
    }

    return count;
  }, 0);
};

export const hasUnreadNotifications = (notifications = []) =>
  getUnreadNotificationCount(notifications) > 0;
